import React, { useEffect, useRef, useState } from "react";
import Loader from "../../loader/loader";
import { FILE_SIZE_LABEL, isValidMultiple } from "./lib/fileHelper";
import "./image-uploader.scss";
import PreviewFile from "./preview-files";

const ImageUploader = ({ disabled, ...props }) => {
    const fileInputRef = useRef();
    const imageRef = useRef();
    const [isDragActive, setIsDragActive] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    useEffect(() => {
        setIsUploading(false);

        if (props.file === null) {
            fileInputRef.current.value = "";
        }
    }, [props.file]);

    const openFilePicker = (e) => {
        if (disabled) {
            return false;
        }

        fileInputRef.current.click();
    };

    const onFileChange = () => {
        const fileList = fileInputRef.current.files;
        const files = fileList && fileList.length > 0 ? fileList : null;

        if (!files || (props.allowedFiles && isValidMultiple(files, props.allowedFiles).length !== fileList.length)) {
            fileInputRef.current.value = "";
            props.updateField([]);

            return false;
        }

        readImage(files[0]);
        props.updateField(files);
    };

    const onDragEnter = (e) => {
        if (disabled) {
            return false;
        }

        e.preventDefault();
        setIsDragActive(true);
    };
    const onDragLeave = (e) => {
        if (disabled) {
            return false;
        }

        e.preventDefault();
        setIsDragActive(false);
    };
    const onDragOver = (e) => {
        if (disabled) {
            return false;
        }

        e.preventDefault();
    };

    const onDrop = (e) => {
        if (disabled) {
            return false;
        }

        e.preventDefault();

        if (
            !e.dataTransfer.files ||
            (props.allowedFiles && isValidMultiple(e.dataTransfer.files, props.allowedFiles).length !== e.dataTransfer.files.length)
        ) {
            fileInputRef.current.value = "";
            props.updateField([]);
            setIsDragActive(false);

            return false;
        }

        fileInputRef.current.files = e.dataTransfer.files;

        props.updateField(e.dataTransfer.files);

        setIsDragActive(false);
        setIsUploading(true);
    };

    const renderUploadDragDrop = () => {
        const loadingHtml = isUploading ? <Loader /> : null;
        const actionClass = isUploading ? " -upload-active" : isDragActive ? " -drag-active" : "";

        return (
            <div
                className={`upload-box${actionClass}`}
                onClick={openFilePicker}
                onDragEnter={onDragEnter}
                onDragOver={onDragOver}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
            >
                {loadingHtml}
            </div>
        );
    };

    const readImage = (file) => {
        if (file) {
            var reader = new FileReader();

            const $image = imageRef.current;
            reader.onload = function (e) {
                if ($image) {
                    $image.setAttribute("src", e.target.result);
                }
            };

            reader.readAsDataURL(file);
        }
    };

    const hasImage = props.file ? true : false;
    const imageOrUpload = !hasImage && !props.isQA && !props.isCompleted ? renderUploadDragDrop() : null;
    const allowedFiles = props.allowedFiles ? props.allowedFiles.join(", ") : "";

    const filePreviews = [];
    const fileList = fileInputRef && fileInputRef.current ? fileInputRef.current.files : null;
    const files = fileList && fileList.length > 0 ? fileList : [];
    for (let i = 0; i < files.length; i++) {
        filePreviews.push(<PreviewFile key={`file_${i}`} file={files[i]} />);
    }

    return (
        <div className="image-uploader">
            <small>File size must be less than {FILE_SIZE_LABEL}</small>
            <div className="hide">
                <input
                    type="file"
                    onChange={onFileChange}
                    accept={allowedFiles}
                    ref={fileInputRef}
                    multiple={props.multiple}
                    disabled={disabled}
                ></input>
            </div>
            {imageOrUpload}
            <div onClick={openFilePicker}>{filePreviews}</div>
            {allowedFiles && <small>Allowed files: {allowedFiles}</small>}
        </div>
    );
};

ImageUploader.defaultProps = {
    multiple: false,
};

export default ImageUploader;
